import PropTypes from "prop-types"
import React, { Component } from "react"

import { _get, arraysEqual } from "../utility/generic"

export default class Sidebar extends Component {
  static propTypes = {
    groups: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    groupHeights: PropTypes.arrayOf(PropTypes.number).isRequired,
    keys: PropTypes.shape({
      groupIdKey: PropTypes.string,
      groupTitleKey: PropTypes.string,
      groupRightTitleKey: PropTypes.string,
    }).isRequired,
    groupRenderer: PropTypes.func,
    isRightSidebar: PropTypes.bool,
  }

  static defaultProps = {
    groupRenderer: null,
    isRightSidebar: false,
  }

  shouldComponentUpdate(nextProps) {
    const { groups, keys, width, groupHeights, height } = this.props

    return !(
      arraysEqual(nextProps.groups, groups) &&
      nextProps.keys === keys &&
      nextProps.width === width &&
      nextProps.groupHeights === groupHeights &&
      nextProps.height === height
    )
  }

  renderGroupContent(
    group,
    isRightSidebar,
    groupTitleKey,
    groupRightTitleKey,
    elementStyle,
  ) {
    const { groupRenderer } = this.props

    if (groupRenderer) {
      return React.createElement(groupRenderer, {
        group,
        isRightSidebar,
        elementStyle,
      })
    }
    return _get(group, isRightSidebar ? groupRightTitleKey : groupTitleKey)
  }

  render() {
    const {
      width,
      groupHeights,
      height,
      isRightSidebar,
      groups,
      keys: { groupIdKey, groupTitleKey, groupRightTitleKey },
    } = this.props

    const sidebarStyle = {
      width: `${width}px`,
      height: `${height}px`,
    }

    const groupsStyle = {
      width: `${width}px`,
    }

    const groupLines = []
    let i = 0

    groups.forEach((group, index) => {
      const elementStyle = {
        height: groupHeights[index],
        lineHeight: groupHeights[index],
      }

      groupLines.push(
        <div
          key={_get(group, groupIdKey)}
          className={`rct-sidebar-row${
            i % 2 === 0 ? ` rct-sidebar-row-even` : ` rct-sidebar-row-odd`
          }`}
          style={elementStyle}
        >
          {this.renderGroupContent(
            group,
            isRightSidebar,
            groupTitleKey,
            groupRightTitleKey,
            elementStyle,
          )}
        </div>,
      )
      i += 1
    })

    return (
      <div
        className={`rct-sidebar${isRightSidebar ? ` rct-sidebar-right` : ``}`}
        style={sidebarStyle}
      >
        <div style={groupsStyle}>{groupLines}</div>
      </div>
    )
  }
}
